import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_APPLICATION_CONFIGURATIONS = "GET_APPLICATION_CONFIGURATIONS";

export const service = async (data) => {
  const options: object = {
    url: `/Api/User/GetApplicationConfigurations`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_APPLICATION_CONFIGURATIONS, service, mock);
